<template>
  <div class="range-info range-info-border">
    <!-- First row: text left, icon right -->
    <div class="d-flex justify-content-between">
      <span class="ml-2">{{ output }}</span>
      <img
        src="../../assets/img/icons/expand.png"
        :alt="messageType"
        class="expand_icon mr-2"
        @click="expand = !expand"
      />
    </div>

    <!-- Second row: expanded content -->
    <div v-if="expand" class="expanded-content text-left ml-2 text-primary">
       <span v-for="(eachrange, index) in ranges" :key="eachrange.qualitative"> {{ eachrange.valueMin }}-{{ eachrange.valueMax }} ({{  eachrange.qualitative }}) <span v-if="index != ranges.length - 1"> | </span> </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ranges: {
      type: Array,
      default: () => [],
    },
    output: {
      type: String,
      required: true,
    },
    // add this if you actually use messageType
    messageType: {
      type: String,
      default: "info",
    },
  },
  data() {
    return {
      rangemessage: [],
      expand: false,
    };
  },
  async mounted() {
    await this.setranges();
  },
  methods: {
    setranges() {
      console.log("ranges", this.ranges);
    },
  },
};
</script>

<style scoped>
.range-info {
  padding: 2px;
  margin-top: 4px;
  border-radius: 6px;
  color: #68696b;
  font-size: 12px;
}

/* First row: flex, icon on the right */
.message-row {
  display: flex;
}

/* Let text take remaining space */
.message-text {
  flex: 1;
}

/* Icon on the right */
.expand_icon {
  width: 16px;
  height: 16px;
  margin-left: 8px;
  cursor: pointer;
}

.range-info-border {
  border: 1px solid #0fdce0;
  border-right: 4px solid #31beed;
}

/* Optional styling for expanded area */
.expanded-content {
  margin-top: 4px;
}
</style>
